import type { Step } from "react-joyride";

export const categoryFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂຫມວດຫມູ່ຟອມ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="category-form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ຫມວດຫມູ່. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າຫມວດຫມູ່ນີ້ສຳລັບຫຍັງ. ຕົວຢ່າງ: 'ຟອມ HR', 'ຟອມການເງິນ', 'ຟອມການບໍລິການ'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບຫມວດຫມູ່ນີ້ (ບໍ່ບັງຄັບ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-icon"]',
    content:
      "ນີ້ແມ່ນຊ່ອງໄອຄອນ. ທ່ານສາມາດໃສ່ຊື່ໄອຄອນສຳລັບຫມວດຫມູ່ນີ້ (ບໍ່ບັງຄັບ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-order"]',
    content:
      "ນີ້ແມ່ນຊ່ອງລຳດັບ. ທ່ານສາມາດກຳນົດລຳດັບການສະແດງຜົນຂອງຫມວດຫມູ່ (ບໍ່ບັງຄັບ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-active"]',
    content:
      "ນີ້ແມ່ນ checkbox ສະຖານະ. ທ່ານສາມາດກຳນົດວ່າຫມວດຫມູ່ນີ້ໃຊ້ງານຫຼືບໍ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ສ້າງຫມວດຫມູ່' (ສຳລັບການສ້າງໃໝ່) ຫຼື 'ບັນທຶກການແກ້ໄຂ' (ສຳລັບການແກ້ໄຂ) ເພື່ອບັນທຶກຫມວດຫມູ່ຂອງທ່ານ.",
    placement: "top",
  },
];
